// @ts-nocheck
import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Skeleton from '@mui/material/Skeleton';
import { ALIASES_PER_PAGE } from '../../Contantes/Constantes';

function AliasSkeletonItem() {
    return (
        <ListItem sx={{ borderRadius: '30px', alignItems: 'flex-start', gap: 1 }}>
            <div style={{ flex: 1, paddingRight: '5%' }}>
                <Skeleton variant="text" width="55%" height={32} />
                <Skeleton variant="text" width="38%" height={22} sx={{ mt: 0.5 }} />
                <Skeleton variant="text" width="75%" height={22} sx={{ mt: 0.5 }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton variant="circular" width={40} height={40} />
            </div>
        </ListItem>
    );
}

export default function AliasSkeletonList() {
    return (
        <List>
            {Array.from({ length: ALIASES_PER_PAGE }).map((_, i) => (
                <AliasSkeletonItem key={i} />
            ))}
        </List>
    );
}
